import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

export interface AiUsageLimitEventAdapterParams {
  limitType:
    | 'quota_exceeded'
    | 'rate_limit_exceeded'
    | 'global_rate_limit_exceeded'
    | 'service_unavailable';
}

type AiUsageLimitEventData = {
  limit_type:
    | 'quota_exceeded'
    | 'rate_limit_exceeded'
    | 'global_rate_limit_exceeded'
    | 'service_unavailable';
};

export class AiUsageLimitEventAdapter extends EventAdapter<AiUsageLimitEventData> {
  protected intercomEventKey = null;

  constructor({ limitType }: AiUsageLimitEventAdapterParams) {
    super();

    this.eventData = {
      limit_type: limitType,
    };
  }
  protected amplitudeEventFunction = function addQuizModalEvent(
    event: AiUsageLimitEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.AiUsageLimit, event);
  };
}
